import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button } from "../../atoms/button";
import { TextField } from "../../atoms/textfield";
import get from "lodash/get";
import assetify from "@quintype/framework/assetify";
import NewsLetterConfig from "../../../../../config/newsletter";
import { subscribeToMailchimp } from "../../pages/newsletter/api";
import { isValidEmail } from "../../../utils";
import LoadingIcon from "../../../../assets/images/loader.svg";
import "./stop-press.m.css";

const StopPress = ({ collection, planName }) => {
  const { subscriptionData } = NewsLetterConfig();
  const domainSlug = useSelector(state =>
    get(state, ["qt", "domainSlug"], null)
  );
  const name = get(collection, ["associated-metadata", "name"], "Stop Press");
  const getPlanName = planName || name;
  const getPlanDetails =
    subscriptionData.filter(item => item.title == getPlanName) || [];

  const [showLoader, setShowLoader] = useState();
  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const [subscribeMailStatus, setSubscribeMailStatus] = useState([]);

  const [selectedPlan, setSelectedPlan] = useState(planName);

  // console.log({ subscriptionData, collection, planName });

  const onChange = e => {
    setEmail(e.target.value);
    e.target.value ? setError("") : setError("Please provide Email !!");
  };

  // const onSubmitClick = () => {
  //   console.log("clicked");
  //   if (email) {
  //     if (!isValidEmail(email)) {
  //       setError("Invalid Email !!");
  //     } else {
  //       setShowLoader(true);
  //       subscribeToMailchimp({
  //         email: email,
  //         listId5: "aa2c780e6c"
  //       })
  //         .then(status => {
  //           console.log(status);
  //           setSubscribeMailStatus(status);
  //           setEmail("");

  //           setShowLoader(false);
  //           setTimeout(function() {
  //             setSubscribeMailStatus([]);
  //             setCheckedItems([]);
  //           }, 4000);
  //         })
  //         .catch(err => {
  //           console.log(err);
  //         });
  //     }
  //   } else {
  //     setError("Please provide Email !!");
  //   }
  // };

  const handleSubmit = async () => {
    if (email) {
      if (isValidEmail(email)) {
        setShowLoader(true);
        const plan = subscriptionData.find(plan => plan.title === planName);

        try {
          const result = await subscribeToMailchimp({
            email,
            listId1: plan.id === "first" ? plan.mailChimplistId : "",
            listId2: plan.id === "second" ? plan.mailChimplistId : "",
            listId3: plan.id === "third" ? plan.mailChimplistId : "",
            listId4: plan.id === "fourth" ? plan.mailChimplistId : "",
            listId5: plan.id === "fifth" ? plan.mailChimplistId : "",
            listId6: plan.id === "sixth" ? plan.mailChimplistId : ""
          });

          console.log({ result });

          setSubscribeMailStatus(result);
          setShowLoader(false);
          setEmail("");

          setTimeout(() => {
            setSubscribeMailStatus([]);
          }, 3000);
        } catch (error) {
          console.error(error);
          setError("Something went wrong. Please try again later.");
        }
      } else {
        setError("Please provide a valid email address.");
      }
    } else {
      setError("A valid email is required.");
    }
  };

  return (
    getPlanDetails.length > 0 && (
      <div styleName="stop-process-container">
        <h3 styleName="stop-process">
          <span styleName="stop">{getPlanDetails[0].title}</span>
        </h3>
        <p styleName="description">{getPlanDetails[0].description}</p>
        {/* {!domainSlug ? (
          <div styleName="subcribe-bottom">
            <div styleName="subscribe-view-content ">
              <TextField
                value={email}
                error={error}
                onChange={onChange}
                placeholder="Type your email"
              />
              <Button
                // href={`/newsletter-signup?${decodeURIComponent(
                //   getPlanDetails[0].title
                // )}`}
                onClick={handleSubmit}
              >
                {" "}
                Sign Up
              </Button>
            </div>
          </div>
        ) : ( */}
        <div styleName="btn-input">
          <div styleName="subscribe-view-content ">
            {showLoader === true && (
              <div styleName="modal">
                <div styleName="modal-content">
                  <img src={assetify(LoadingIcon)} alt="loading" />
                </div>
              </div>
            )}
            <TextField
              value={email}
              error={error}
              onChange={onChange}
              placeholder="Type your email"
            />
            <button styleName="submit-btn" onClick={handleSubmit}>
              {!domainSlug ? "Sign up" : "साइन अप"}
            </button>
          </div>
        </div>
        {/* )} */}
        {subscribeMailStatus && subscribeMailStatus.length > 0 && (
          <div styleName="modal">
            <div styleName="modal-content show-message">
              Thanks for signing up. See you in your inbox soon.
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default StopPress;
